import React from 'react'
import { Image, ImageProps } from 'react-native'

type HybridImageProps = ImageProps & {
  // Used by some web image components (e.g. Next.js). We accept it to keep call-sites
  // consistent, but intentionally do not pass it through to the native Image.
  priority?: boolean
}

const trimProps = (props: HybridImageProps): HybridImageProps => {
  // Avoid console errors, remove unnecessary props
  const {
    accessibilityDisabled,
    onStartShouldSetResponder,
    onResponderGrant,
    onResponderMove,
    onResponderRelease,
    onResponderTerminate,
    onResponderTerminationRequest,
    priority,
    ...rest
  } = props

  return rest
}

export const HybridImage: React.FC<HybridImageProps> = (props: HybridImageProps) => {
  return <Image {...trimProps(props)} />
}

HybridImage.getSize = Image.getSize

export default HybridImage
